import React, { useState, useEffect } from 'react';
import './App.css';

const Kurumbilgi = () => {
  const [kurumBilgi, setKurumBilgi] = useState({
    kurumad: '',
    logourl: '',
    updatetime: '',
    updateuser: ''
  });
  const [logoFile, setLogoFile] = useState(null);
  const [kurumAd, setKurumAd] = useState('');
  const [logo, setLogo] = useState('');
  const company = localStorage.getItem('company');

  useEffect(() => {
    fetch(`https://api.idekod.com.tr/api/kurumbilgi/${company}`)
      .then((response) => response.json())
      .then((data) => {
        setKurumAd(data.kurumad);
        setLogo(data.logourl);
      })
      .catch((error) => {
        console.error('Kurum bilgisi alınırken hata oluştu:', error);
      });
  }, [company]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result;
      const sizeInBytes = (base64String.length * (3 / 4)) - (base64String.endsWith('==') ? 2 : 1);
      const sizeInMB = sizeInBytes / (1024 * 1024);

      if (sizeInMB > 5) {
        alert('Resim çok büyük. Lütfen daha küçük bir resim seçin.');
      } else {
        setLogoFile(base64String);
      }
    };

    reader.readAsDataURL(file);
  };

  const handleUpdate = async () => {
    const companyKisa = localStorage.getItem('company');
    const username = localStorage.getItem('username');

    const updatedData = {
      ...kurumBilgi,
      logourl: logoFile || kurumBilgi.logourl,
      updatetime: new Date().toISOString().slice(0, 19).replace('T', ' '),
      updateuser: username,
      company: companyKisa
    };

    if (window.confirm('Bilgileri güncellemek istiyor musunuz?')) {
      try {
        const response = await fetch('https://api.idekod.com.tr/api/kurumbilgiguncel', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedData),
        });

        if (!response.ok) throw new Error('Güncelleme başarısız');

        alert('Kurum bilgileri başarıyla güncellendi!');
        window.location.reload();
      } catch (error) {
        console.error('Kurum bilgileri güncellenirken hata oluştu:', error);
      }
    }
  };

  return (
    <div className="page">
      <div className="page__head">
        <div>
          <h1 className="page__title">Kurum Bilgileri</h1>
          <p className="page__subtitle">Kurum adını ve logosunu güncelleyin</p>
        </div>
      </div>

      <div className="card">
        <div className="card__header">
          <h2 className="card__title">Kurum Ayarları</h2>
        </div>

        <div className="card__body form">
          <div className="form-grid">
            <div className="stat-tile">
              <div className="stat-tile__label">Mevcut Kurum Adı</div>
              <div className="stat-tile__value">{kurumAd || '-'}</div>
            </div>
            <div className="stat-tile">
              <div className="stat-tile__label">Mevcut Logo</div>
              {logo ? <img src={logo} alt="Logo" className="logo-preview u-mt-2" /> : <div className="stat-tile__value">Logo bulunamadı</div>}
            </div>
          </div>

          <div className="form-field">
            <label className="form-label">Yeni Kurum Adı</label>
            <input
              type="text"
              value={kurumBilgi.kurumad}
              onChange={(e) => setKurumBilgi({ ...kurumBilgi, kurumad: e.target.value })}
              className="form-control"
              placeholder="Yeni kurum adı"
            />
          </div>

          <div className="form-field">
            <label className="form-label">Yeni Logo Yükle</label>
            <input type="file" onChange={handleFileChange} className="form-control" accept="image/*" />
            {logoFile && <img src={logoFile} alt="Seçilen logo" className="logo-preview u-mt-2" />}
          </div>

          <button onClick={handleUpdate} className="btn btn--primary btn--block btn--lg">
            Güncelle
          </button>
        </div>
      </div>
    </div>
  );
};

export default Kurumbilgi;
